import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getIosPaymentSafeRoute } from "../utils/platform";

/**
 * Immediate redirect for payment/subscription routes on iOS — no payment UI rendered.
 */
export default function IosPaymentRedirect({ fallback = "/home" }) {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (isAuthenticated() && user) {
    return <Navigate to={getIosPaymentSafeRoute(user)} replace />;
  }

  return <Navigate to={fallback} replace />;
}
